import React from 'react';

const locationContext = React.createContext({
  state: {}, actions: {}, config: {},
});

export default locationContext;
